// extracted by mini-css-extract-plugin
module.exports = {"agrisud-page-body":"home_agrisud-page-body__1UW-6","mark":"home_mark__3aAim","none":"home_none__2P18C","title":"home_title__2U93c","bg":"home_bg__2F-PJ"};